<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingRulesWorkspace from '@/views/Banking/Rules/BankingRulesWorkspace.vue'

definePage({ meta: { ...PageMeta.Banking.Rules.Meta, pageTitle: PageMeta.Banking.Rules.Title } })
</script>

<template>
  <BankingRulesWorkspace />
</template>
